/** @jsxImportSource @emotion/react */
import { selectChampionships } from 'modules/main/store/main-page';
import StatusDistributionBar, {
  type StatusItem,
} from 'modules/main/ui/components/section/components/status-distribution-bar/status-distribution-bar';
import Value from 'modules/main/ui/components/section/components/value/value';
import Section from 'modules/main/ui/components/section/section';
import { Pages } from 'modules/navigation/domain/enums/pages';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { theme } from 'styles/theme/theme';
import type { DivProps } from 'typings';
import UDColorableIcon from 'ud-ui/components/icon/colorable-icon';
import Text from 'ud-ui/components/text';

interface IProps extends DivProps {
  loading?: boolean;
}

function SectionTournaments(props: IProps) {
  const { loading, ...rest } = props;
  const navigate = useNavigate();

  const { championships, total } = useSelector(selectChampionships);
  const statusItems: StatusItem[] = [
    {
      status: 'shading',
      count: championships.preparing,
      label: 'подготовка',
    },
    {
      status: 'primary',
      count: championships.stared,
      label: 'начат',
    },
    {
      status: 'secondary',
      count: championships.ended,
      label: 'завершен',
    },
  ];

  return (
    <Section
      icon={<UDColorableIcon name="cup" size={17.345} />}
      header="Турниры"
      buttonText="Добавить турнир"
      isShowButton={total === 0}
      onClickButton={() => navigate(Pages.TOURNEYS.CREATE)}
      onClickExtend={() => navigate(Pages.TOURNEYS.INDEX)}
      loading={loading}
      {...rest}
    >
      <Value value={total.toString()} label="всего" className="mb-5" />
      {total > 0 ? (
        <StatusDistributionBar data={statusItems} />
      ) : (
        <Text isNew type="subtitle-4" color={theme.colors.WhiteGray} className="flex-center flex-1">
          Нет ни одного турнира, это надо исправлять!
        </Text>
      )}
    </Section>
  );
}

export default SectionTournaments;
